import {IModalServiceInstance} from 'angular-ui-bootstrap';
import ITranslateService = angular.translate.ITranslateService;

export class BerechnungsdetailController {

    static $inject = ['$uibModalInstance', '$translate', 'einkommensabzug',
        'vermoegensabzug', 'anrechenbarerschaden', 'minimalschaden', 'steuerbaresvermoegen', 'steuerbareseinkommen'];

    constructor(private $uibModalInstance: IModalServiceInstance, $translate: ITranslateService,
                private einkommensabzug: number, private vermoegensabzug: number, private anrechenbarerschaden: number,
                private minimalschaden: number, private steuerbaresvermoegen: number, private steuerbareseinkommen: number) {


    }

    ok(): void {
        this.$uibModalInstance.close();
    };

    cancel(): void {
        this.$uibModalInstance.dismiss('cancel');
    };
}



// WEBPACK FOOTER //
// ./src/app/core/dialog/BerechnungsdetailController.ts